import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Colors, ModalProps } from 'Types';
import {
	Button,
	FontAwesome,
	ModalBox,
	ModalBoxFooter,
	Scrollbar
} from 'Elements';
import styles from 'partials/modal/modalbox-search-filter.module.scss';

interface Props extends ModalProps {
	isLoading: boolean;
	totalItems: number;
	children: ReactNode;
	onReset: (() => void) | false;
	type: 'job' | 'event' | 'internship';
}

export const ModalBoxSearchFilter: FC<Props> = ({
	isOpen,
	onClose,
	isLoading,
	totalItems,
	children,
	onReset,
	type
}) => {
	const { t } = useTranslation();

	return (
		<ModalBox
			isOpen={isOpen}
			onClose={onClose}
			title="title.filters"
			className={styles.modal}>
			{onReset && (
				<div className="d-flex w-100 align-items-center pb-3 mb-3 border-bottom border-mid-gray">
					<span
						role="button"
						className="fs-small py-1 text-red d-flex align-items-center gap-2"
						onClick={onReset}>
						<FontAwesome icon="xmark" size="sm" swapOpacity />
						{t('button.reset-filters')}
					</span>
				</div>
			)}
			<Scrollbar className={styles.scrollbar}>{children}</Scrollbar>
			<ModalBoxFooter className="justify-content-between border-top border-mid-gray pt-4">
				<Button color={Colors['white-gray']} onClick={onClose}>
					{t('button.cancel')}
				</Button>
				<Button disabled={isLoading} onClick={onClose}>
					{t(`button.view-n-${type}`, {
						count: totalItems
					})}
				</Button>
			</ModalBoxFooter>
		</ModalBox>
	);
};
